import React from 'react'

export const ExtraChargeModalBody = ({
  serviceTxn: { reservation, serviceInfo },
}) => (
  <div className="space-y-4">
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
      <div className="flex items-start gap-3">
        <svg
          className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-0.5"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <div>
          <h3 className="font-semibold text-yellow-900 mb-1">
            Extra Charge Detected
          </h3>
          <p className="text-sm text-yellow-800">
            Service guest count exceeds reservation. Additional charges may
            apply.
          </p>
        </div>
      </div>
    </div>

    <div className="overflow-hidden border border-gray-200 rounded-lg">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Guest Type
            </th>
            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Reservation
            </th>
            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Service
            </th>
            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Difference
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          <tr
            className={
              (serviceInfo.guestPaxAdult || 0) >
              (reservation.guestPaxAdult || 0)
                ? 'bg-red-50'
                : ''
            }
          >
            <td className="px-4 py-3 text-sm font-medium text-gray-900">
              Adult
            </td>
            <td className="px-4 py-3 text-sm text-center text-gray-700">
              {reservation.guestPaxAdult || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center font-semibold text-gray-900">
              {serviceInfo.guestPaxAdult || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center">
              {(serviceInfo.guestPaxAdult || 0) >
              (reservation.guestPaxAdult || 0) ? (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  +
                  {(serviceInfo.guestPaxAdult || 0) -
                    (reservation.guestPaxAdult || 0)}
                </span>
              ) : (
                <span className="text-gray-400">-</span>
              )}
            </td>
          </tr>
          <tr
            className={
              (serviceInfo.guestPaxChild || 0) >
              (reservation.guestPaxChild || 0)
                ? 'bg-red-50'
                : ''
            }
          >
            <td className="px-4 py-3 text-sm font-medium text-gray-900">
              Child
            </td>
            <td className="px-4 py-3 text-sm text-center text-gray-700">
              {reservation.guestPaxChild || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center font-semibold text-gray-900">
              {serviceInfo.guestPaxChild || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center">
              {(serviceInfo.guestPaxChild || 0) >
              (reservation.guestPaxChild || 0) ? (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  +
                  {(serviceInfo.guestPaxChild || 0) -
                    (reservation.guestPaxChild || 0)}
                </span>
              ) : (
                <span className="text-gray-400">-</span>
              )}
            </td>
          </tr>
          <tr
            className={
              (serviceInfo.guestPaxInfant || 0) >
              (reservation.guestPaxInfant || 0)
                ? 'bg-red-50'
                : ''
            }
          >
            <td className="px-4 py-3 text-sm font-medium text-gray-900">
              Infant
            </td>
            <td className="px-4 py-3 text-sm text-center text-gray-700">
              {reservation.guestPaxInfant || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center font-semibold text-gray-900">
              {serviceInfo.guestPaxInfant || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center">
              {(serviceInfo.guestPaxInfant || 0) >
              (reservation.guestPaxInfant || 0) ? (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  +
                  {(serviceInfo.guestPaxInfant || 0) -
                    (reservation.guestPaxInfant || 0)}
                </span>
              ) : (
                <span className="text-gray-400">-</span>
              )}
            </td>
          </tr>
          <tr
            className={
              (serviceInfo.luggageAmount || 0) >
              (reservation.luggageAmount || 0)
                ? 'bg-red-50'
                : ''
            }
          >
            <td className="px-4 py-3 text-sm font-medium text-gray-900">
              Luggage
            </td>
            <td className="px-4 py-3 text-sm text-center text-gray-700">
              {reservation.luggageAmount || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center font-semibold text-gray-900">
              {serviceInfo.luggageAmount || 0}
            </td>
            <td className="px-4 py-3 text-sm text-center">
              {(serviceInfo.luggageAmount || 0) >
              (reservation.luggageAmount || 0) ? (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  +
                  {(serviceInfo.luggageAmount || 0) -
                    (reservation.luggageAmount || 0)}
                </span>
              ) : (
                <span className="text-gray-400">-</span>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)
